import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../auth/supabase';

function friendlyError(description: string) {
  if (/already exist|already linked|already registered|already been registered/i.test(description)) {
    return 'This email already has a Flowcount password account. Use “Sign in with email instead” on the sign-in screen, or ask your manager for help.';
  }
  if (/unapproved|not allowed|redirect/i.test(description)) {
    return 'Sign-in is not allowed from this address yet. Ask the Flowcount administrator to check the sign-in settings.';
  }
  return 'Google sign-in did not complete. Try again from the sign-in screen.';
}

export function AuthCallbackPage() {
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!supabase) { if (!cancelled) setError('Sign-in is not available here.'); return; }
      const url = new URL(window.location.href);
      const params = url.searchParams;
      const hashParams = new URLSearchParams(url.hash.replace(/^#/, ''));
      const problem = params.get('error_description') ?? params.get('error') ?? hashParams.get('error_description') ?? hashParams.get('error');
      if (problem) {
        window.history.replaceState({}, '', '/auth/callback');
        if (!cancelled) setError(friendlyError(problem));
        return;
      }
      const code = params.get('code');
      if (code) await supabase.auth.exchangeCodeForSession(code).catch(() => undefined);
      // Google sign-in normally completes while this page loads: the client
      // detects the returned session automatically. Wait briefly for it.
      for (let attempt = 0; attempt < 20; attempt += 1) {
        const { data } = await supabase.auth.getSession();
        if (data.session) { window.location.replace('/app'); return; }
        await new Promise((resolve) => setTimeout(resolve, 250));
      }
      if (!cancelled) setError('Sign-in took too long or did not finish. Go back and try again.');
    })();
    return () => { cancelled = true; };
  }, []);
  return <div className="public-wrap"><section className="public-card">
    <div className="public-brand">Flowcount</div>
    <h1>Signing in…</h1>
    {error
      ? <><div className="error">{error}</div><Link className="primary wide" to="/app">Back to sign in</Link></>
      : <p>One moment while we finish signing you in.</p>}
  </section></div>;
}
